/**
 * Notification classification + navigation helpers.
 *
 * System-generated notifications (linked to a listing) navigate to the
 * relevant listing page on click. Marketing notifications (admin broadcasts)
 * have no linked entity and open a read-only detail modal instead.
 */

export const SYSTEM_TYPES = new Set([
  "NEW_LISTING",
  "NEW_LISTING_MATCH",
  "AGENT_MATCH",
  "BUYER_MATCH",
  "LISTING_FAVORITED",
  "NEED_HOST_FOR_OPEN_HOUSE",
]);

/** A notification is "marketing" if it is not a known system-generated type. */
export const isMarketing = (notification) =>
  !!notification && !SYSTEM_TYPES.has(notification.type);

/**
 * Role-aware listing detail path.
 * AGENT has a dedicated read-only listing view; ADMIN / ADMIN 1 / BUYER_AGENT
 * use the company-context listing page.
 */
export const getListingPath = (companyId, listingId, roleName) => {
  if (roleName === "AGENT") {
    return `/company/${companyId}/agent/listings/${listingId}/view`;
  }
  return `/company/${companyId}/listings/${listingId}`;
};

/**
 * Role-aware path to the Notifications page (history now lives there).
 * AGENT is restricted to `/agent/*` routes by ProtectedLayout, so it needs the
 * agent-prefixed variant; other company-context roles use the plain path.
 */
export const getHistoryPath = (companyId, roleName) => {
  if (!companyId) return "/administrator/notifications";
  if (roleName === "AGENT") {
    return `/company/${companyId}/agent/notifications`;
  }
  return `/company/${companyId}/notifications`;
};

/** Read the logged-in user's role name from localStorage (set on login). */
export const getStoredRoleName = () => {
  try {
    const user = JSON.parse(localStorage.getItem("userInfo"));
    return user?.role?.name || null;
  } catch {
    return null;
  }
};
